import type { useForm } from "hooks";
import type { BootstrapableForm, Option } from "types";
import type { Identity } from "./entities";
import type { OnboardingFormProps } from "ui/forms/ECommerce/Onboarding/types";

export const enum FormField {
    FullName = 'fullName',
    DateOfBirth = 'dateOfBirth',
    ResidentialAddress = 'residentialAddress',
    Nationality = 'nationality',
    IdentityFileKey = 'identityFileKey',
    AddressFileKey = 'addressFileKey',
    LegalForm = 'legalForm',
};

export type UboIdentity = Identity;

export type OnboardingIdentityVerificationForm =
    & Omit<
        BootstrapableForm<UboIdentity, {
            legalForm: Option[];
        }>,
        | 'initialValues'
    >
    & {
        readonly initialValues: UboIdentity;
    };

export type OnboardingIdentityVerificationProps =
    & OnboardingFormProps
    & OnboardingIdentityVerificationForm
    & ReturnType<typeof useForm<UboIdentity>>;
